<template>
    <div>
        <div v-if="showopenmodal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-md" style="display: block !important">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header pb-0">
                                    <h5 class="modal-title text-center pull-left w-100 d-block mt-4 pb-0">
                                        Time Format Settings
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" @click="cancelAction()">
                                        <i class="material-icons">close</i>
                                    </button>
                                </div>

                                <!-- Modal Body -->
                                <div class="modal-body p-0">
                                    <div>
                                        <!-- Spinner -->
                                        <div v-if="showspinner" class="appointmentlist-spinner">
                                            <div class="processing_popup full-spinner" style="
                                                visibility: visible;
                                                top: -68px;
                                                height: 261px;
                                                z-index: 9999999999;
                                            ">
                                                <div class="spinner cover-spin">
                                                    <div class="bounce1"></div>
                                                    <div class="bounce2"></div>
                                                    <div class="bounce3"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Time Format Radio Buttons -->
                                        <div class="pl-3 pr-3 pb-3 pt-3">
                                            <label class="radio-container" style="width: 40% !important">
                                                12-Hour
                                                <input
                                                    name="timeformat"
                                                    type="radio"
                                                    value="12hr"
                                                    v-model="selectedTimeFormat"
                                                />
                                                <span class="radio-checkmark"></span>
                                            </label>
                                            <label class="radio-container" style="width: 50% !important">
                                                24-Hour
                                                <input
                                                    name="timeformat"
                                                    type="radio"
                                                    value="24hr"
                                                    v-model="selectedTimeFormat"
                                                />
                                                <span class="radio-checkmark"></span>
                                            </label>
                                        </div>

                                        <!-- Preview Section -->
                                        <div class="col-md-12 mb-3 mt-3">
                                            <div class="time-preview-box p-3 rounded bg-light text-center">
                                                <span class="preview-label d-block mb-1">Preview</span>
                                                <span class="preview-time">{{ previewTime }}</span>
                                            </div>
                                        </div>

                                        <!-- Footer Buttons -->
                                        <div class="pull-left mb-4 pl-5 pr-5 col-md-12 mt-2">
                                            <slot name="footer">
                                                <button
                                                    type="button"
                                                    class="secondary-btn ripple pull-left"
                                                    @click="resetSetting()"
                                                >
                                                    Reset
                                                </button>
                                                <button
                                                    type="button"
                                                    class="primary-btn ripple pull-right"
                                                    @click="saveSettings()"
                                                >
                                                    Save
                                                </button>
                                            </slot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <Messages
            v-if="isdisplaymsg"
            v-bind:datamessage="sucessmsgtext"
            v-bind:iserror="iserrormsg"
            v-on:closemsg="closeMessage"
            v-bind:isVisible="isdisplaymsg"
        ></Messages>
    </div>
</template>

<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
import Messages from "@/components/MessagePopup/Messages";
import SubscriptionApi from "@/api/subscription.js";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "TimeFormatSetting",

    props: ["showmodal", "parentprop"],

    components: { Messages },

    data() {
        return {
            // Message popup
            isdisplaymsg: false,
            sucessmsgtext: "",
            iserrormsg: false,

            showopenmodal: false,
            showspinner: false,

            selectedTimeFormat: "12hr",   // "12hr" | "24hr"
            prevSelectedFormat: "12hr",   // used by Reset

            loggedInUser: null,
        };
    },
    watch: {
        showmodal(newVal) {
            this.showopenmodal = newVal;
            if (newVal) {
                this.showspinner = false;
                this.getTimeFormatSetting();
            }
        }
    },
    computed: {

        /**
         * Live preview of what the chosen format looks like right now.
         */
        previewTime() {
            const now = new Date();
            if (this.selectedTimeFormat === "12hr") {
                let hours = now.getHours();
                const minutes = now.getMinutes().toString().padStart(2, "0");
                const ampm = hours >= 12 ? "PM" : "AM";
                hours = hours % 12 || 12;
                return `${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
            } else {
                const hours = now.getHours().toString().padStart(2, "0");
                const minutes = now.getMinutes().toString().padStart(2, "0");
                return `${hours}:${minutes}`;
            }
        },
    },

    methods: {
        /** Load persisted setting – local storage first, API as fallback */
        getTimeFormatSetting() {
            const stored = JSON.parse(window.localStorage.getItem("tenantbusinesssetup"));
            
            if (stored) {
                if (stored.is24timeFormat) {
                    this.selectedTimeFormat = "24hr";
                } else {
                    this.selectedTimeFormat = "12hr";
                }
                this.prevSelectedFormat = this.selectedTimeFormat;
            } else {
                SubscriptionApi.getbusinesssetup()
                    .then((response) => {
                        if (response.data && response.data.result) {
                            const result = response.data.result;

                            localStorage.setItem("tenantbusinesssetup", JSON.stringify(result));

                            if (result.is24timeFormat) {
                                this.selectedTimeFormat = "24hr";
                            } else {
                                this.selectedTimeFormat = "12hr";
                            }
                            this.prevSelectedFormat = this.selectedTimeFormat;
                        }
                    })
                    .catch((error) => console.log(error));
            }
        },

        saveSettings() {
            var self = this;
            self.showspinner = true;

            Axios.request({
                method: "post",
                url: rest_service.baseURL + "/staff/updatetimeformat",
                headers: {
                    x_tenant_id: localStorage.tenantid,
                    role_unique_id: self.loggedInUser.role.unique_id,
                    route_entity_name: "/staff",
                    loggedin_user_unique_id: self.loggedInUser.unique_id,
                    Authorization: localStorage.accesstoken,
                    "Content-Type": "application/json",
                },
                withCredentials: false,
                data: JSON.stringify(self.selectedTimeFormat),
            })
                .then((respo) => {
                    if (respo.data && respo.data.result && respo.status) {
                        // Merge the new value into cached business-setup
                        const is24 = self.selectedTimeFormat == "24hr";
                        const cached = JSON.parse(window.localStorage.getItem("tenantbusinesssetup")) || {};
                        cached.is24timeFormat = is24;
                        window.localStorage.setItem("tenantbusinesssetup", JSON.stringify(cached));

                        self.prevSelectedFormat = self.selectedTimeFormat;
                        self.showspinner = false;
                        self.parentprop.openclossetimeformatpopup = false;

                        self.isdisplaymsg = true;
                        self.iserrormsg   = false;
                        self.sucessmsgtext =
                            "Time Format Settings " +
                            self.$store.state.helper.alertmessage.saved;

                        setTimeout(() => { self.closeMessage(); }, 3000);
                    } else {
                        self.showspinner = false;
                        self.parentprop.openclossetimeformatpopup = false;
                        self.isdisplaymsg = true;
                        self.iserrormsg   = true;
                        self.sucessmsgtext = respo.data.result;
                        setTimeout(() => { self.closeMessage(); }, 3000);
                    }
                })
                .catch(() => {
                    self.showspinner = false;
                    self.parentprop.openclossetimeformatpopup = false;
                    self.isdisplaymsg = true;
                    self.iserrormsg   = true;
                    self.sucessmsgtext =
                        "Time Format Settings " +
                        self.$store.state.helper.alertmessage.failupdate;
                    setTimeout(() => { self.closeMessage(); }, 3000);
                });
        },

        resetSetting() {
            this.selectedTimeFormat = this.prevSelectedFormat;
        },

        cancelAction() {
            this.selectedTimeFormat = this.prevSelectedFormat;
            this.showopenmodal = false;
            this.parentprop.openclossetimeformatpopup = false;
        },

        closeMessage() {
            this.isdisplaymsg = false;
        },
    },

    created() {
        this.loggedInUser = JSON.parse(localStorage.loggedInUserInfo);
        this.getTimeFormatSetting();
    },
};
</script>

<style scoped>
.radio-container {
    width: auto !important;
    margin-left: 15px;
}

/* ── Preview box ── */
.time-preview-box {
    border: 1px dashed #ccc;
}

.preview-label {
    font-size: 11px;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.preview-time {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.04em;
}

/* ── Modal boilerplate (same as parent component) ── */
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

input[type="checkbox"],
input[type="radio"] {
    height: 19px !important;
    width: 100%;
    left: 0px;
    z-index: 1;
}
</style>